import type { FrontendWidget } from '../types';
import { NavigationCtasComponent } from './NavigationCtasComponent';
import type { NavigationCtasConfig, NavigationCtasResolved } from './types';

export const navigationCtasWidget: FrontendWidget<
  NavigationCtasConfig,
  NavigationCtasResolved
> = {
  componentType: 'widgets.navigation-ctas',
  displayName: 'Navigation CTAs',
  ComponentA: NavigationCtasComponent,
  resolveSync: (config) => config,
};
